import { useState } from 'react'
import OrderStatusDetails from './OrderStatusDetails'
import OrderStatusForm from './OrderStatusForm'
import { IOrderStatusDetails } from '@/src/modules/OrderStatus/types'

export const OrderStatus = () => {
    const [orderStatusDetails, setOrderStatusDetails] =
        useState<IOrderStatusDetails | null>(null)

    return orderStatusDetails ? (
        <OrderStatusDetails
            orderStatusDetails={orderStatusDetails}
            setOrderStatusDetails={setOrderStatusDetails}
        />
    ) : (
        <OrderStatusForm setOrderStatusDetails={setOrderStatusDetails} />
    )
}
